import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles(() => ({
  scrollableSpace: (props) => ({
    maxWidth: '100%',
    maxHeight: '100%',
    overflow: 'hidden',
    cursor: 'move',
    fontFamily: 'inherit',
    userSelect: 'none',
    position: 'relative',
    '& > .inner': {
      display: 'flex',
      flexDirection: props.direction === 'x' ? 'row' : 'column',
      backfaceVisibility: 'hidden',
      height: 'auto',
      width: 'fit-content',
      minWidth: '100%',
      transition: 'transform 100ms ease-out',
    },
  }),
}));

export default useStyle;
